<router-outlet></router-outlet>

<emi-version-renderer></emi-version-renderer>
